"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var findLastWithKey = _fp.findLast.convert({
  cap: false
});
var _default = exports["default"] = findLastWithKey;
module.exports = exports.default;